import styled from 'styled-components';

export const TabList = styled.div`
    display: flex;
    gap: 4px;
    border-bottom: 1px solid #e5e7eb;
    // overflow-x: auto;
`;

export const TabPanel = styled.div`
    padding-top: 20px;
`;

export const TabButton = styled.button<{ $active: boolean }>`
    position: relative;
    padding: 12px 16px;
    margin-bottom: -1px;
    border: none;
    border-bottom: 2px solid ${p => p.$active ? '#337ab7' : 'transparent'};
    background: transparent;
    color: ${p => p.$active ? '#1d5a96' : '#6b7280'};
    font-size: 14px;
    font-weight: ${p => p.$active ? 600 : 500};
    white-space: nowrap;
    cursor: pointer;
    transition: color 0.15s ease, border-color 0.15s ease;

    &:hover {
        color: ${p => p.$active ? '#1d5a96' : '#111827'};
        border-bottom-color: ${p => p.$active ? '#337ab7' : '#d1d5db'};
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        box-shadow: inset 0 0 0 2px rgba(51, 122, 183, 0.4);
        border-radius: 6px 6px 0 0;
    }
`;

export const TabContent = styled.div`
    padding: 20px;
`;